module.exports = __webpack_public_path__ + "assets/img/webmoney.30ac1300.svg";